/* eslint-disable no-console */

import {httpGet, httpPost, httpDelete} from './http.service';
import {IPresentationParamValues, Param} from '../incase-domain/presentationParamValues/IPresentationParamValues';

export const fetchPresentationParamValuesService = (presentationId: string): Promise<IPresentationParamValues> => {
    return httpGet(`editor/presentationParamValues/${presentationId}`).catch((error) => {
        console.log(error);
        return {errors: error.response.data};
    });
};

export const addPresentationParamValueService = (presentationId: string, newParam: Param[]): Promise<IPresentationParamValues> => {
    return httpPost(`editor/presentationParamValues/${presentationId}/addParam`, newParam).catch((error) => {
        return {errors: error.response.data};
    });
};

export const deletePresentationParamValueService = (presentationId: string, paramsToDelete: Param[]): Promise<IPresentationParamValues> => {
    return httpDelete(`editor/presentationParamValues/${presentationId}/deleteParam`, paramsToDelete).catch((error) => {
        return {errors: error.response.data};
    });
};
